import * as React from 'react'
import classnames from 'classnames'
import { Tooltip } from 'react-tippy'
import NumberFormat from 'react-number-format'
import * as CurrencyFormat from 'react-currency-format'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type Props = {
  title: string
  isLoading?: boolean
  isCurrency?: boolean
  currentYearValue: number
  previousYearValue?: number
}

const percentageChange = (currentValue: number, previousValue: number) => {
  if (currentValue > previousValue) {
    if (!previousValue) { return 0 }
    return ((currentValue / previousValue) -1 ) * 100
  } else {
    if (!currentValue) { return 0 }
    return ((previousValue / currentValue) -1 ) * -100
  }
}

const currencyText = (value?: number) => {
  return (
    <CurrencyFormat
      prefix={'$'}
      decimalScale={2}
      value={value || 0}
      displayType="text"
      thousandSeparator={true}
      fixedDecimalScale={true}
    />
  )
}

const AccidentSummaryCard = (props: Props) => (
  <div className="ggcard" style={{ marginRight: '20px', minWidth: '120px', height: '108px' }}>
    <div className="card-body d-flex flex-column align-items-center justify-content-center">
      {props.isLoading
        ? (
          <h5 className="card-title d-flex align-items-center">
            <FontAwesomeIcon spin icon={['fas', 'spinner']} />
          </h5>
        )
        : (
          <h5 className="card-title d-flex align-items-center">
            {!props.isCurrency && props.currentYearValue}
            {props.isCurrency && currencyText(props.currentYearValue)}

            {!!props.previousYearValue &&
              <NumberFormat
                thousandSeparator
                value={percentageChange(props.currentYearValue, props.previousYearValue)}
                suffix="%" decimalScale={2} fixedDecimalScale={true} displayType="text"
                renderText={
                  value => (
                    <Tooltip followCursor className="d-flex" trigger="mouseenter" html={
                      <div className="ggmouseover d-flex flex-column align-items-center p-3">
                        <span>Last year</span>
                        <span className="font-weight-bold">
                          {props.isCurrency &&
                            <CurrencyFormat
                              prefix={'$'}
                              decimalScale={2}
                              displayType="text"
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                              value={props.previousYearValue}
                            />
                          }
                          {!props.isCurrency && props.previousYearValue}
                        </span>
                      </div>
                    }>
                      <span
                        style={{ fontSize: '13px' }}
                        className={classnames(
                          'badge badge-secondary ml-2',
                          { 'badge-danger': (props.previousYearValue || 0) < props.currentYearValue || 0 },
                          { 'badge-success': (props.previousYearValue || 0) > (props.currentYearValue || 0) }
                        )}
                      >
                        {value}
                        {props.previousYearValue &&
                          <FontAwesomeIcon
                            className="ml-2"
                            icon={props.previousYearValue < props.currentYearValue! ? 'arrow-up' : 'arrow-down'} />
                        }
                      </span>
                    </Tooltip>
                  )
                }
              />
            }
          </h5>
        )
      }
      <span className="card-subtitle mt-1">{props.title}</span>
    </div>
  </div>
)

export default AccidentSummaryCard



// WEBPACK FOOTER //
// ./src/routes/accidents/components/AccidentSummaryCard.component.tsx